import { useMemo } from 'react';

import { useDucatClient } from '@/context/DucatClientCtx';

import { UnitUtxoOutput, useQueryRuneUtxos } from '../wallet/useQueryRuneUtxos';

type RuneBalanceData = {
  isLoading: boolean;
  runeBalance: number;
  unitUtxos: UnitUtxoOutput[];
};

export function useRuneBalance(): RuneBalanceData {
  const { wallet } = useDucatClient();

  const { data: runeUtxosResponse, isLoading } = useQueryRuneUtxos({
    address: wallet?.acct.runes.address,
  });

  const runeBalance = useMemo(() => {
    if (runeUtxosResponse) {
      const unitCents = runeUtxosResponse.outputs.filter((v) => !v.spent).reduce((acc, utxo) => acc + utxo.unit_amount, 0);
      // console.log(`>>> runeBalance: $ ${unitCents / 100}`);
      return unitCents / 100;
    }

    return 0;
  }, [runeUtxosResponse]);

  const unitUtxos = useMemo(() => {
    return runeUtxosResponse?.outputs.filter((v) => !v.spent) || [];
  }, [runeUtxosResponse]);

  return { runeBalance, unitUtxos, isLoading };
}
